module.exports = __webpack_public_path__ + "static/media/IMG_3822.138e9257.JPG";